export enum SignUpStatus {
  AccountCreated = "AccountCreated",
  AccountCreationFailed = "AccountCreationFailed",
}
